import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { GrupoService } from '../../../../services/grupo.service';
import { DataTableDirective } from 'angular-datatables';
import { Grupo } from '../../../../models/grupo';

@Component({
	selector: 'app-personal',
	templateUrl: './personal.component.html',
	styleUrls: ['./personal.component.css'],
	providers: [GrupoService]
})
export class PersonalComponent implements OnInit {

	public grupo: Grupo;
	public identity;
	public token;
	public status;
	public message_success;
	public message_error;
	public status_update;
	public message_update_success;
	public message_update_error;
	public status_delete;
	public message_delete_success;
	public message_delete_error;
	public grupos: any = [];
	public dtOptions: DataTables.Settings = {};
	public dtTrigger: Subject<any> = new Subject();
	public nombre;
	public apellidos;
	public telefono;
	public email;
	public password;
	public rol_id;
	public grupo_id;
	public estatus;

	@ViewChild(DataTableDirective)
	public dtElement: DataTableDirective;

	constructor(
		private _route: ActivatedRoute,
		private _router: Router,
		private _grupoService: GrupoService
	) {
		this.identity = this._grupoService.getIdentity();
		this.token = this._grupoService.getToken();
		this.grupo = new Grupo(1, 2, '', '', '', '', '', '', '', '', 1);
	}

	ngOnInit() {
		this.dtOptions = {
			pagingType: 'full_numbers',
			pageLength: 10
		}
		this.getGrupos();
	}

	getGrupos() {
		this._grupoService.getGrupos(this.token).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.grupos = response.grupos;
					this.dtTrigger.next();
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.message_error = error;
				}
			}
		);
	}

	create(form) {
		this._grupoService.create(this.token, this.grupo).subscribe(
			response => {
				// Obtener el token 
				if (response.status == 'success') {
					this.status = response.status;
					this.message_success = response.message;
					form.reset();
					this._grupoService.getGrupos(this.token).subscribe(
						response => {
							// Obtener el token 
							if (response.status == 'success') {
								this.grupos = response.grupos;
								this.rerender();
							}
						},
						error => {
							if (error['status'] == 401) {
								this._router.navigate(['logout/1']);
							} else {
								this.message_error = error;
							}
						}
					);
				} else {
					this.status = 'error';
					this.message_error = response.message;
				}
			},
			error => {

				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.status = 'error';
					this.message_error = error['error']['message'];
				}

			}
		);
	}

	update() {
		this.nombre = $("#nomAct").val();
		this.apellidos = $("#apAct").val();
		this.telefono = $("#tlAct").val();
		this.email = $("#emAct").val();
		this.password = $("#psAct").val();
		this.estatus = $("#estAct").val();
		this.rol_id = $("#rolAct").val();
		this.grupo_id = $("#userAct").val();

		this.grupo = new Grupo(this.grupo_id, this.rol_id, this.nombre, this.apellidos, this.email, this.telefono, this.password, '', '', this.estatus, 1);

		this._grupoService.update(this.token, this.grupo_id, this.grupo).subscribe(
			response => {
				console.log(response)
				if (response.status == 'success') {
					this.status_update = response.status;
					this.message_update_success = response.message;
				} else {
					this.status_update = 'error';
					this.message_update_error = response.message;
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					this.status = 'error';
					this.message_error = error['error']['message'];
				}
			}
		);
	}

	delete(id) {
		this._grupoService.delete(this.token, id).subscribe(
			response => {
				if (response.status == 'success') {
					this.status_delete = response.status;
					this.message_delete_success = response.message;
					location.reload();
				}
			},
			error => {
				if (error['status'] == 401) {
					this._router.navigate(['logout/1']);
				} else {
					alert(error['message']);
				}

			}
		);
	}

	rerender(): void {
		this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
			// Destroy the table first
			dtInstance.destroy();
			// Call the dtTrigger to rerender again
			this.dtTrigger.next();
		});
	}

}
